import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// FontAwesome.
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

// Components.
import IconButton from 'app/client/components/IconButton';

// Styled.
import * as S from './styled';

const CreateButton = ({ type, onClick, customLabel, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      onClick={onClick}
      icon={byPrefixAndName.fal['circle-plus']}
      alternate
      disabled={disabled}
    >
      <S.FullLabel>{customLabel?.full || t('core:common.createOfType', { type })}</S.FullLabel>
      <S.SmallLabel>{customLabel?.small || t('core:common.create')}</S.SmallLabel>
    </IconButton>
  );
};

CreateButton.propTypes = {
  type: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  customLabel: PropTypes.shape({
    full: PropTypes.string,
    small: PropTypes.string,
  }),
  disabled: PropTypes.bool,
};

export default CreateButton;
